import { render, staticRenderFns } from "./CreateNarrative.vue?vue&type=template&id=93bf5fa6&lang=pug&"
import script from "./CreateNarrative.vue?vue&type=script&lang=js&"
export * from "./CreateNarrative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports